import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { type ThemeTypedColorProps, getDirection } from "../../../../../themes/common";
import { theme } from "../../theme/toyotaTheme";

export const BadgeRounded = styled.button<{ hasLink?: boolean } & ThemeTypedColorProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    font-family: ${theme.fonts.semiBold};
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: ${theme.colors.primaryBlack};
    background-color: ${theme.colors.primaryWhite};
    border: 2px solid ${theme.colors.primaryBlack};
    border-radius: 10px;

    ${({ hasLink }) =>
        hasLink &&
        css`
            cursor: pointer;
        `};

    &:not(:nth-last-child(1)) {
        margin-${getDirection("right")}: 4px;
    }
`;

export const SpotlightWrapper = styled.span`
    margin-${getDirection("left")}: ${theme.space[1]}px;
    line-height: 1.4rem;
`;

export const Wrapper = styled.span<SpaceProps>`
    position: relative;
    top: -3px;
    margin-${getDirection("left")}: ${theme.space[1]}px;
    z-index: 100;
    ${space};
`;
